export default __webpack_public_path__ + "static/opus-logo-full-5b555fabefe6bc8449c3ca5e1c589462.png";